import { useId } from '@atlaskit/ds-lib/use-id';

// useId generates a number which cannot be used as an Id for html elements as is, therefore we need to prefix it with text.
export const usePrefixedUID = (prefix: string = 'element') => `${prefix}-${useId()}`;
